var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sub-header" }, [
      _c(
        "div",
        { staticClass: "question-num" },
        [
          _c("span", [_vm._v("题号：")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "180px" },
              attrs: { "value-key": "num" },
              model: {
                value: _vm.currentQuestion,
                callback: function ($$v) {
                  _vm.currentQuestion = $$v
                },
                expression: "currentQuestion",
              },
            },
            _vm._l(_vm.questionList, function (q, i) {
              return _c(
                "el-option",
                {
                  key: i,
                  attrs: {
                    label: "" + (q.bigNum || "") + (q.smallNum || ""),
                    value: q,
                  },
                },
                [
                  _c("join-topic", {
                    attrs: {
                      direction: "row",
                      fontSize: 14,
                      texts: [q.bigNum, q.smallNum],
                      nullText: q.question,
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "refresh-btn" }, [
        _c("span", [_vm._v("数据统计截止到 " + _vm._s(_vm.updated_at))]),
        _c(
          "label",
          {
            on: {
              click: function ($event) {
                return _vm.getReadQuality()
              },
            },
          },
          [_vm._v("刷新")]
        ),
      ]),
    ]),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "table-wrapper", staticStyle: { margin: "16px 32px" } },
      [
        _c(
          "el-table",
          {
            staticClass: "table-mini-th",
            attrs: {
              size: "small",
              "max-height": "750px",
              border: "",
              data: _vm.qualityTableData,
              "row-class-name": _vm.rowClass,
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: "老师姓名",
                align: "center",
                prop: "teacherName",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "批阅角色", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.teacherType == 1
                        ? _c("span", [_vm._v("批阅老师")])
                        : _vm._e(),
                      scope.row.teacherType == 2
                        ? _c("span", [_vm._v("仲裁老师")])
                        : _vm._e(),
                      scope.row.teacherType == 3
                        ? _c("span", [_vm._v("三评老师")])
                        : _vm._e(),
                      scope.row.teacherType == 4
                        ? _c("span", [_vm._v("批阅组长")])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "阅卷总任务",
                "min-width": "110px",
                sortable: "",
                align: "center",
                prop: "totalCount",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "已阅卷",
                align: "center",
                sortable: "",
                prop: "alreadyCount",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "平均分",
                align: "center",
                sortable: "",
                prop: "avgScore",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            scope.row.avgScore
                              ? scope.row.avgScore.toFixed(2)
                              : scope.row.avgScore
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "最高分",
                sortable: "",
                align: "center",
                prop: "maxScore",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "最低分",
                sortable: "",
                align: "center",
                prop: "minScore",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "150px",
                label: "阅卷速度（秒/份）",
                sortable: "",
                align: "center",
                prop: "avgGradingTime",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            scope.row.avgGradingTime
                              ? scope.row.avgGradingTime.toFixed(2)
                              : scope.row.avgGradingTime
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "min-width": "130px",
                label: "抽样复评一致率",
                sortable: "",
                align: "center",
                prop: "reviewAccuracyRate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.teacherType == 1
                        ? _c("div", [
                            scope.row.reviewAccuracyRate !== null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        scope.row.reviewAccuracyRate
                                      ).toFixed(2)
                                    ) + "%"
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _c("div", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart" }, [
      _c("div", { attrs: { id: "readQualityChart" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }